import { useMutation } from "@apollo/react-hooks";
import { gql } from "apollo-boost";

import { STATUSES } from "../constants";
import { dispatchListingSaved } from "../events/listingSaved";
import { findSavedBannerElement } from "../helpers";

const CREATE_LISTING_JOURNEY = gql`
  mutation create_listing_journey($input: CreateListingJourneyInput!) {
    create_listing_journey(input: $input) {
      listing_journey {
        id
        status
      }
    }
  }
`;

export const useCreateListingJourney = (
  { listingId, listingType },
  callback
) => {
  const [createListingJourneyMutation] = useMutation(CREATE_LISTING_JOURNEY, {
    onCompleted: ({ create_listing_journey: { listing_journey } }) => {
      const { id, status } = listing_journey;
      dispatchListingSaved({ listingId, listingType, status, id });

      const savedBanner = findSavedBannerElement(listingType, listingId);
      if (savedBanner != null) {
        savedBanner.classList.remove("unsaved");
      }

      if (window.dataLayer) {
        window.dataLayer.push({
          event: "custom_event",
          event_category: "save",
          event_action: listingType,
          event_label: listingId
        });
      }

      if (callback) callback(listing_journey);
    }
  });

  const createListingJourney = () =>
    createListingJourneyMutation({
      variables: {
        input: {
          listing_id: listingId,
          listing_class: listingType.toLowerCase(),
          status: STATUSES.saved.value
        }
      }
    });

  return [createListingJourney];
};
